export default () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ position: 'relative' }}
  >
    <path d="M17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3" stroke="#4151E6" />
    <path d="M16 1V7" stroke="#4151E6" />
    <path d="M19 4L13 4" stroke="#4151E6" />
    <path d="M10 14C11.6569 14 13 12.6569 13 11H7C7 12.6569 8.34315 14 10 14Z" fill="#4151E6" />
    <circle cx="8" cy="8" r="0.5" fill="#4151E6" stroke="#4151E6" />
    <circle cx="12" cy="8" r="0.5" fill="#4151E6" stroke="#4151E6" />
  </svg>
)
